
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.782 14.083a1.05 1.05 0 010 1.485 1.05 1.05 0 01-1.485 0l-5.17-5.208-5.207 5.207a1.05 1.05 0 01-1.485 0 1.05 1.05 0 010-1.485l5.209-5.205-5.21-5.246a1.05 1.05 0 010-1.485 1.05 1.05 0 011.485 0l5.208 5.248 5.207-5.207a1.05 1.05 0 011.485 0 1.05 1.05 0 010 1.485L10.61 8.876z","fill":"#245389","data-name":"Group 133524"}})])
          )
        }
      }
    